// removed by extract-text-webpack-plugin
module.exports = {"bar":"P4OXfi1eIogFDwYCBaLpw","hidden":"_1I-eJgZnsO1Kxm1Cus12jm","logo":"_2XwtzG4wcTtSj1-b_ujRg5","content":"_2fRkG2-CRTW0Gfx24LA05U","hint":"_1Zlf_JTyYyAiYkjlsSi19E"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CookiePolicyBar/CookiePolicyBar.scss
// module id = 1258
// module chunks = 1